import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TrackingService } from '../../services/tracking/tracking.service';
import { StorageService } from '../../services/storage/storage.service';
import { DefaultSearchButtonComponent } from '../default-search-button/default-search-button.component';
import { CancelButtonComponent } from '../cancel-button/cancel-button.component';
import { AppPipes } from '../../pipes';
import { ClientService } from '../../services/client/client.service';

@Component({
    selector: 'app-cookie-dialog',
    templateUrl: './cookie-dialog.component.html',
    styleUrls: ['./cookie-dialog.component.less'],
    imports: [
        CommonModule,
        MatButtonModule,
        DefaultSearchButtonComponent,
        CancelButtonComponent,
        AppPipes,
    ]
})
export class CookieDialogComponent implements OnInit {

  public visible = false;

  constructor(
    private tracking: TrackingService,
    private storage: StorageService,
    private client: ClientService,
  ) {}

  ngOnInit() {
    this.visible = !this.storage.get('cookie_consent') && this.client?.client?.customization?.showSystemCookieNotification ? true: false;
  }

  accept() {
    this.tracking.updateConsent('accepted');
    this.visible = false;
  }

  decline() {
    this.tracking.updateConsent('rejected');
    this.visible = false;
  }
}
